/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { createContext, useContext } from 'react';

const DepartmentPageTrackingContext = createContext(null);

export const useDepartmentPageTracking = () => useContext(DepartmentPageTrackingContext) || (() => {});

export const useIsDepartmentPageTrackingActive = () => Boolean(useContext(DepartmentPageTrackingContext));

export default DepartmentPageTrackingContext;
